/* sdo-pays-calculateur.js — 13/10/2026 (Soleil d'Or)
   Calculateur de livraison du panier tiroir : la liste des pays (238 pays et leurs
   provinces, ≈ 70 Ko) n'est plus écrite dans chaque page (voir sections/cart-drawer.liquid).
   Le <select id="CartDrawerCountry" data-sdo-pays-src="…"> arrive vide ; ce script le
   remplit à la première ouverture du calculateur, puis relance la préparation d'origine
   du thème (setupCountries : pays principaux en tête, provinces). Sans l'attribut, rien
   ne change. Le contenu du tiroir étant re-rendu à chaque mise à jour du panier, les
   nouveaux calculateurs sont repris au vol. */
(function () {
  'use strict';

  function brancher(calc) {
    if (calc.__sdoPays) return;
    var sel = calc.querySelector('#CartDrawerCountry[data-sdo-pays-src]');
    if (!sel) return;
    calc.__sdoPays = true;

    function charger() {
      return fetch(sel.getAttribute('data-sdo-pays-src'), { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          /* setupCountries a déjà tourné une fois sur la liste vide : on retire ses
             groupes vides avant de la relancer sur la vraie liste. */
          var groupes = sel.querySelectorAll('optgroup');
          for (var i = 0; i < groupes.length; i++) groupes[i].remove();
          sel.insertAdjacentHTML('beforeend', html);
          sel.removeAttribute('data-sdo-pays-src');
          if (typeof calc.setupCountries === 'function') calc.setupCountries();
        })
        .catch(function (e) {
          calc.__sdoPays = false;
          if (window.console) console.warn('Calculateur de livraison : pays non chargés', e);
        });
    }

    if (!calc.classList.contains('hidden')) {
      charger();
      return;
    }
    var obs = new MutationObserver(function () {
      if (!calc.classList.contains('hidden')) {
        obs.disconnect();
        charger();
      }
    });
    obs.observe(calc, { attributes: true, attributeFilter: ['class'] });
  }

  function tout() {
    var calcs = document.querySelectorAll('cart-shipping-calculator');
    for (var i = 0; i < calcs.length; i++) brancher(calcs[i]);
  }

  function demarrer() {
    tout();
    var tiroir = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
    if (tiroir && window.MutationObserver) {
      new MutationObserver(tout).observe(tiroir, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer, { once: true });
  } else {
    demarrer();
  }
})();
